import { render, staticRenderFns } from "./bindEmail.vue?vue&type=template&id=bf6dbf38&"
import script from "./bindEmail.vue?vue&type=script&lang=js&"
export * from "./bindEmail.vue?vue&type=script&lang=js&"
import style0 from "./bindEmail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bf6dbf38')) {
      api.createRecord('bf6dbf38', component.options)
    } else {
      api.reload('bf6dbf38', component.options)
    }
    module.hot.accept("./bindEmail.vue?vue&type=template&id=bf6dbf38&", function () {
      api.rerender('bf6dbf38', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginconfig/components/bindEmail.vue"
export default component.exports